import { Tabs, TabsProps } from "antd";
import Container from "components/Desktop/Container";
import Header from "components/Desktop/Header";
import MobileContainer from "components/Mobile/Container";
import MobileHeader from "components/Mobile/Header";
import { IS_BREAKPOINT_DESKTOP } from "constants/common";
import RegisterForm from "./components/RegisterForm";
import LoginForm from "./components/LoginForm";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useSearchParams } from "react-router-dom";
import useUserStore from "stores/user";
const items = [
  {
    label: <div className="text-xl">เข้าสู่ระบบ</div>,
    key: "1",
    children: <LoginForm />,
  },
  {
    label: <div className="text-xl">สมัครสมาชิก</div>,
    key: "2",
    children: <RegisterForm />,
  },
];
const AuthenPage = () => {
  const [searchParams] = useSearchParams();
  const { user } = useUserStore();
  const navigation = useNavigate();
  const isDesktop = useMediaQuery({
    query: IS_BREAKPOINT_DESKTOP,
  });

  const tab = searchParams.get("tab");
  const [activeTab, setActiveTab] = useState<string>("2");
  const renderTabBar: TabsProps["renderTabBar"] = (props, DefaultTabBar) => {
    return <DefaultTabBar {...props} />;
  };

  const handleOnChangeTab = (value: string) => {
    setActiveTab(value);
  };
  useEffect(() => {
    if (tab) {
      if (tab.toLowerCase() === "register") {
        setActiveTab("2");
      } else {
        setActiveTab("1");
      }
    }
  }, [tab]);

  useEffect(() => {
    if (user) {
      navigation("/");
    }
  }, []);

  const authTabs = (
    <Tabs
      className="auth-form"
      activeKey={activeTab}
      centered
      items={items}
      renderTabBar={renderTabBar}
      onChange={handleOnChangeTab}
    />
  );

  if (isDesktop) {
    return (
      <div>
        <Container>
          <Header />
        </Container>
        <Container>
          <main className="min-h-[700px] bg-[#F7F4FA] pt-8 p-4 flex justify-center">
            <div className="w-[800px] bg-[#F7F4FAE5]">{authTabs}</div>
          </main>
        </Container>
      </div>
    );
  }

  return (
    <div>
      <MobileContainer>
        <MobileHeader />
        <main className="min-h-[700px] bg-[#F7F4FA] pt-8 p-4">
          <div className="w-full bg-[#F7F4FAE5]">{authTabs}</div>
        </main>
      </MobileContainer>
    </div>
  );
};
export default AuthenPage;
